// extracted by mini-css-extract-plugin
export default {"tabSelectBox":"tab-switch_tabSelectBox__WY6H4","tabSelectBoxMobile":"tab-switch_tabSelectBoxMobile__o6tF9","buttonTab":"tab-switch_buttonTab__mp6Ks"};